/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_CardsInputs */



/**
* | output |
* | --- |
* | "Cards" |
*
* @param {Nav_CardsInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const nav_cards = /** @type {((inputs?: Nav_CardsInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_CardsInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Karten")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Cartes")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("卡牌")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("卡牌")
	if (locale === "ko") return /** @type {LocalizedString} */ ("카드")
	return /** @type {LocalizedString} */ ("Cards")
});